import "twin.macro";

import { useState } from "react";

import { Button } from "@mui/material";

import { Brand } from "@models/Brand";

import BrandManagementTable from "./BrandManagementTable";
import BrandModal from "./BrandModal";

type EditAction = {
  action: "edit";
  brand: Brand;
};

type CreateAction = {
  action: "create";
  brand: null;
};

type Action = EditAction | CreateAction;

const BrandManagement = () => {
  const [action, setAction] = useState<Action | null>(null);

  const handleCreateNewBrand = () => {
    setAction({ action: "create", brand: null });
  };

  const handleEditBrand = (brand: Brand) => {
    setAction({ action: "edit", brand });
  };

  return (
    <div tw="space-y-4">
      <BrandManagementTable onEdit={handleEditBrand} />
      <Button variant="contained" tw="mr-auto" onClick={handleCreateNewBrand}>
        Create New Brand
      </Button>
      {action && (
        <BrandModal brand={action.brand} handleClose={() => setAction(null)} />
      )}
    </div>
  );
};

export default BrandManagement;
